import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonServiceService {
  private readonly headersApp_Json: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    this.headersApp_Json = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getArea(page?: number, size?: number, filters?: any): Observable<any> {
    const params = new HttpParams({ fromObject: filters });
    return this.http.get<any>(env.baseUrl + 'Area' + '?page=' + page + '&pageResults=' + size + '&' + params);
  }
  getAreaId(id: string): Observable<any> {
    return this.http.get<any>(env.baseUrl + `Area/${id}`);
  }

  getZoneId(id: string): Observable<any> {
    return this.http.get<any>(env.baseUrl + `Zone/${id}`);
  }

  addAddtionalFields(field: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + `Field`, field);
  }

  getAddtionalFields(type: any, productLinee?: any): Observable<any> {
    let url = env.baseUrl + `Field?type=${type}`;
    if (productLinee !== null) {
      const params = new HttpParams({ fromObject: productLinee });
      if (params.keys().length > 0) {
        url += (url.includes('?') ? '&' : '?') + params.toString();
      }
    }
    return this.http.get<any>(url);
  }

  editAdditionalField(field: any): Observable<any> {
    return this.http.put<any>(env.baseUrl + `Field`, field);
  }

  deleteAdditionalField(id: any): Observable<any> {
    return this.http.delete<any>(env.baseUrl + `Field/${id}`);
  }
}
